export class EarnedMedia {
  clickValue: any;
  currency: any;
}
